import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { DsButton } from '@frontend/ui/button';
import { DynamicHtmlDirective } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { AccountMenuTaskBaseComponent } from './task-base.component';

@Component({
    imports: [CommonModule, DynamicHtmlDirective, TrustAsHtmlPipe, IconCustomComponent, DsButton],
    selector: 'vn-am-adhoc-task',
    templateUrl: 'task.html',
})
export class AdhocTaskComponent extends AccountMenuTaskBaseComponent implements OnInit {
    constructor() {
        super();
    }

    ngOnInit(): void {
        if (!this.item?.layout) {
            this.item.layout = 'adhoc';
        }
    }
}
